import {
  Box,
  Divider,
  Flex,
  RangeSlider,
  RangeSliderThumb,
  RangeSliderTrack,
  Text,
} from '@chakra-ui/react';
import { KeyTermUnit } from '@client/graphql/__generated__/types';
import { useIsMobile } from '~/common/hooks/useIsMobile';
import { formatToCurrency } from '~/services/document/utils/number';
import { formatRangeValue } from '../common.utils';

interface OutOfRangeSectionProps {
  value: number;
  unit: KeyTermUnit;
  dotColor?: string;
  isGreaterThanRange: boolean;
  showValue?: boolean;
}

export const OutOfRangeSection = ({
  value,
  unit,
  dotColor = 'gray.500',
  isGreaterThanRange,
  showValue = false,
}: OutOfRangeSectionProps) => {
  const isMobile = useIsMobile();
  const formattedRangeLabel = formatRangeValue(value, unit, isMobile);
  const formattedValue =
    unit === KeyTermUnit.DAYS ? `${value}d` : formatToCurrency(value ?? 0);
  const transform = isGreaterThanRange
    ? 'translate(calc(-50% + 1px), 0)'
    : 'translate(calc(-50% - 1px), 0)';

  return (
    <Flex direction="column" height="100%" justifyContent="center" width="30%">
      <Flex gap={1} height="14px" position="relative" width="100%">
        {isGreaterThanRange && (
          <Divider
            borderColor="whiteAlpha.500"
            height="80%"
            orientation="vertical"
            variant="dashed"
          />
        )}
        <Box
          _after={{
            content: '""',
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderTop: '8px solid',
            borderTopColor: dotColor,
            left: '50%',
            position: 'absolute',
            transform,
            transition: 'left 0.3s ease-in-out',
            zIndex: 2,
          }}
          background={dotColor}
          borderRadius="3px"
          bottom="24px"
          data-testid="key-terms-range-chart-offer-label"
          left="50%"
          position="absolute"
          px={1}
          transform={transform}
          transition="left 0.3s ease-in-out"
          zIndex={1}
        >
          <Text
            color="indigo.900"
            fontSize={{ base: 'sm', md: 'md' }}
            fontWeight="medium"
          >
            {showValue ? formattedValue : isMobile ? 'Offer' : 'Your Offer'}
          </Text>
        </Box>
        <RangeSlider
          defaultValue={[50]}
          id="left-slider"
          isDisabled={true}
          mx={2}
        >
          <RangeSliderTrack />
          <RangeSliderThumb
            _disabled={{
              background: dotColor,
            }}
            index={0}
          />
        </RangeSlider>

        {!isGreaterThanRange && (
          <Divider
            borderColor="whiteAlpha.500"
            orientation="vertical"
            variant="dashed"
          />
        )}
      </Flex>
      <Flex justifyContent="center">
        <Text fontSize={{ base: 'sm', md: 'md' }}>{formattedRangeLabel}</Text>
      </Flex>
    </Flex>
  );
};
